import React from "react";
import PremiumAdsSlideshow from "../premium-ads-slideshow/PremiumAdsSlideshow";
import AdList from "../ad-list/AdList";
import { ClassifiedType } from "../../../types/main-types/mainTypes";
import NoContentMessage from "../../common/no-content-message/NoContentMessage";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "../../../styles/css/data-table.css";

interface DisplayAdsSectionProps {
  premiumAdList: ClassifiedType[];
  boostedAdList: ClassifiedType[];
  adList: ClassifiedType[];
  isLastPage: boolean;
  handleNextBtn: () => void;
  handlePreviousBtn: () => void;
  pageNo: number;
}

function DisplayAdsSection({
  premiumAdList,
  boostedAdList,
  adList,
  isLastPage,
  handleNextBtn,
  handlePreviousBtn,
  pageNo,
}: DisplayAdsSectionProps) {
  const hasAds = boostedAdList.length > 0 || adList.length > 0;

  return (
    <div>
      {premiumAdList?.length > 0 && (
        <PremiumAdsSlideshow premiumAdList={premiumAdList} />
      )}
      <AdList adList={boostedAdList} isBoosted={true} />
      <AdList adList={adList} />

      {hasAds ? (
        <div className="data-page__pagination" style={{ margin: "0 1rem" }}>
          <button
            className="data-page__nav-btn"
            disabled={pageNo === 1}
            onClick={handlePreviousBtn}
          >
            <FaChevronLeft size={11} /> Previous
          </button>
          <span className="data-page__page-info">Page {pageNo}</span>
          <button
            className="data-page__nav-btn"
            disabled={isLastPage}
            onClick={handleNextBtn}
          >
            Next <FaChevronRight size={11} />
          </button>
        </div>
      ) : (
        <NoContentMessage message="No Content Found" />
      )}
    </div>
  );
}

export default DisplayAdsSection;
